import React from 'react'

const FaqContainer = () => {
  return (
    <div style={{ textAlign: 'left', width: '80%', margin: 'auto auto' }}>
      <h1 id='summer-camp-faq'>Rolling Robots Camp FAQ</h1>
      <p>Updated 10-15-2025</p>

      <h2>1. What are Rolling Robots Summer/Holiday/Spring Camps?</h2>
      <p>
        Rolling Robots STEM and Robotics Camp is a TECH GENIUS Program for kids
        ages 5 to 15. We believe that your child is a creative tech genius. We
        are offering fun, hands-on, low student to teacher ratio, project-based,
        robotics coding and design camps for your child to learn.
      </p>

      <h2>2. Where are Rolling Robots STEM Camps?</h2>
      <p>
        Rolling Robots offer in-person on-site Summer/Holiday/Spring camps at
        our year-round locations at Rolling Hills Estates, West Los Angeles,
        Pasadena and Irvine. During summer time, we will also offer summer camps
        at Manhattan Beach, Hermosa Beach, Santa Monica, Playa Del Rey, San
        Marino, Tustin, Newport Beach, Costa Mesa and Conejo Valley.
      </p>

      <h2>3. What is the daily/weekly schedule?</h2>
      <p>
        Rolling Robots STEM and Robotics Summer/Holiday/Spring Camp offers the
        most flexibility.
      </p>
      <p>
        We offer camps from 1-day to 1-week long based on the calendar when
        students are out of school. No camps on national holidays. Campers can
        enroll in the morning session, the afternoon session, or both sessions
        (staying at camp during lunch time).
      </p>
      <p>
        The morning session is from 9am to 12pm, and the afternoon session is
        from 1pm to 4pm. The full day session goes from 9am to 4pm with a
        one-hour lunchtime period from 12:00pm - 1:00pm. The lunch hour will be
        complimentary when a camper enrolls in both morning and afternoon
        sessions.
      </p>
      <p>
        Campers can be dropped off up to 15 minutes before the session begins
        and be picked up no later than 15 minutes after the session ends. Any
        drop-offs or pick-ups outside of this 15-minute window will incur an
        extra charge of $1 per minute per camper.
      </p>

      <h2>4. Is there an extended day option?</h2>
      <p>For summer camps only, we will have an extended day option!</p>

      <h2>5. What should my child bring each day?</h2>
      <p>
        Half-day campers should bring snacks and a drink, whereas full-day
        campers should bring lunch, snacks, and drinks for the morning and
        afternoon breaks. Campers can also bring money to buy snacks and drinks
        (ranging from $1 to $5 per item). We highly suggest campers bring a
        water bottle filled with fresh water to stay fully hydrated. Cups of
        water are also available for free upon request.
      </p>
      <p>
        In consideration of the possibility that some children may have a
        nut/peanut allergy, please <strong>DO NOT BRING</strong> any food items
        that may contain nuts or peanuts. It’s recommended for full-day campers
        to bring something they would like to do (reading, drawing, etc.) during
        lunch break.
      </p>

      <h2>6. Will lunch be provided?</h2>
      <p>
        We do not provide lunch. Please pack a lunch (that does not contain any
        nuts or peanuts) if your child is attending both the morning and
        afternoon camps. Water is available at no charge. We highly recommend
        bringing your own water bottle with your child’s full name on it.
        Bottled water, other drinks, and snacks are available for purchase.
      </p>

      <h2>7. Will my child bring home the robots they build during camp?</h2>
      <p>
        Most of the robotics kits we use in our camps will not be taken home
        unless otherwise specified in the camp description. For example, in
        camps such as Junior Robot Builders and Little Engineers, kids build
        their own robots or projects and take them home.
      </p>

      <h2>
        8. Will my child bring home the game they created on the computer during
        camp?
      </h2>
      <p>
        Yes! Campers will be able to take home any games they create during the
        camp. On the last day of camp, campers can bring a flash drive with at
        least 2GB of available space. We can copy the file to the flash drive.
      </p>

      <h2>
        9. My child has never built a robot or programmed on a computer before.
        Is that OK?
      </h2>
      <p>
        Yes. Rolling Robots camps are designed for children of all learning
        backgrounds. We teach the core concepts of STEM, robotics, and computer
        programming/coding. No prior experience is required except for the
        advanced camps. Please use the age guidelines listed when enrolling your
        child so that they will have the best experience possible.
      </p>

      <h2>
        10. My child is a very advanced, high-tech wizard. Will they be bored?
      </h2>
      <p>
        Maybe for about 5 minutes when we are getting everyone started. Rolling
        Robots’ camps are designed to encourage open creativity and deep
        exploration, so once your child is engaged, they will be challenged
        appropriately. If your child does not enjoy the camp, we are always open
        to feedback and can make adjustments for their best experience.
      </p>

      <h2>11. What is the student-to-teacher ratio?</h2>
      <p>
        Rolling Robots highly values that each child is unique. We aim for 6
        campers per instructor to ensure each child gets the attention and
        instruction they need.
      </p>

      <h2>12. Do I pay the full amount up front?</h2>
      <p>
        Yes, you pay the full amount up front. You can add additional sessions
        later as long as space is available.
      </p>

      <h2>13. What is your change/cancellation/refund policy?</h2>
      <p>
        To request a cancellation or change to your camp order, you must email
        us at <strong>contact@rollingrobots.com</strong>. The email subject must
        be <strong>“Camp Cancellation Request - Order ###”</strong>. After
        receiving your email, we will process your request per the following
        policy:
      </p>
      <ol>
        <li>
          Up to 21 days (3 weeks) prior to camp start: Free transfer to another
          camp with the same student name for camps in the same calendar year
          (fee differences may apply). To cancel, $35 per camp per student will
          not be refunded.
        </li>
        <li>
          Between 21 and 7 days prior to camp start: Free transfer to another
          camp with the same student name for camps in the same calendar year
          (fee differences may apply). To cancel, $100 per camp per student will
          not be refunded.
        </li>
        <li>Starting 6 days prior to camp date: No transfer, no refund.</li>
        <li>No refund or transfer for any missed/sick camp days.</li>
        <li>
          If Rolling Robots cancels a camp for any reason, we will assist to
          transfer to another camp or refund the full amount.
        </li>
      </ol>

      <h2>
        14. Is there a discount if I sign up for multiple students and sessions?
      </h2>
      <p>
        Yes, we offer a 5% discount on the total order when more than one camp
        is reserved in the same booking. The discount is automatically applied
        at checkout. This does not apply if multiple camps are booked in
        separate reservations or if other seasonal discounts are active.
      </p>
      <p>Only one discount code is allowed per reservation.</p>

      <h2>15. Is there a sibling/friend discount?</h2>
      <p>
        Yes. See the discount policy above: “Is there a discount if I sign up
        for multiple students and sessions?”
      </p>

      <h2>16. Do you offer membership programs during summer?</h2>
      <p>
        During summer, Rolling Robots continues to offer membership programs at
        year-round locations in Palos Verdes, Pasadena, West Los Angeles, and
        Irvine. The membership programs run from 4pm to 6pm, Monday through
        Friday, and some locations also offer weekend schedules.
      </p>
    </div>
  )
}

export default FaqContainer
